<template>
  <el-dialog
    class="pay-content-dialog dialog"
    title="支付详情"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
    width="500px"
  >
    <div class="pay-content">
      <el-form label-width="120px" label-suffix="：">
        <el-form-item label="交易流水号">
          {{ listData.paymentNo || '-' }}
        </el-form-item>
        <el-form-item label="付款单位类型">
          {{ listData.orderTypeValue || '-' }}
        </el-form-item>
        <el-form-item label="付款单位">
          {{ listData.buyerName || '-' }}
        </el-form-item>
        <el-form-item label="收费类型">
          {{ listData.chargeTypeName || '-' }}
        </el-form-item>
        <el-form-item label="收费企业">
          {{ listData.sellerCompanyName || '-' }}
        </el-form-item>
        <el-form-item label="项目名称">
          {{ listData.projectName || '-' }}
        </el-form-item>
        <el-form-item label="支付方式">
          {{ payTypeDict.translate(listData.payType).label || '-' }}
        </el-form-item>
        <el-form-item label="支付渠道">
          {{ listData.payChannel || '-' }}
        </el-form-item>
        <el-form-item label="支付时间">
          {{ listData.payTime || '-' }}
        </el-form-item>
        <el-form-item label="支付金额(元)">
          {{ strToThousands(listData.amount || '-') }}
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { getInvoicePayListApi } from '@/api/financial/financial'
import { payTypeDict } from '@/dictionary/financial'
import { strToThousands } from '@/utils/utils'

export default {
  name: 'PayContentListDialog',

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    invoiceApplyId: {
      type: [String, Number],
      required: true
    }
  },

  data() {
    return {
      listData: {},
      payTypeDict
    }
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },

  watch: {
    visible(val) {
      if (val) {
        this.getContentList()
      } else {
        this.listData = {}
      }
    }
  },

  methods: {
    strToThousands,

    async getContentList() {
      try {
        const res = await getInvoicePayListApi(this.invoiceApplyId)
        this.listData = res.data[0] || {}
      } catch (err) {
        if (err?.data) {
          this.$message.error(err?.data?.message || '获取失败')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pay-content-dialog {
  ::v-deep .el-dialog {
    width: 60%;
  }
  .pay-content {
    padding: 20px;
    box-sizing: border-box;
    width: 100%;
  }
}
</style>
